import { render, staticRenderFns } from "./FormPaketData.vue?vue&type=template&id=0423b8e7"
import script from "./FormPaketData.vue?vue&type=script&lang=js"
export * from "./FormPaketData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports